module.exports = __webpack_public_path__ + "img/geofisica3_4-3_682.2d8de14b.jpg";